export class SortColumnSpec {
    'column';
    'direction';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "column",
            "baseName": "column",
            "type": "string",
            "format": ""
        },
        {
            "name": "direction",
            "baseName": "direction",
            "type": "SortColumnSpecDirectionEnum",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SortColumnSpec.attributeTypeMap;
    }
    constructor() {
    }
}
export var SortColumnSpecDirectionEnum;
(function (SortColumnSpecDirectionEnum) {
    SortColumnSpecDirectionEnum["SORT_DIRECTION_ASC"] = "ASC";
    SortColumnSpecDirectionEnum["SORT_DIRECTION_DESC"] = "DESC";
})(SortColumnSpecDirectionEnum || (SortColumnSpecDirectionEnum = {}));
